import { getSurfaceCssVariables } from "./surfaceTokens";

/** Apply all surface CSS variables to :root (call on theme change + boot). */
export function applySurfaceTokens(theme = "light") {
  if (typeof document === "undefined") return;

  const root = document.documentElement;
  const vars = getSurfaceCssVariables(theme);

  Object.entries(vars).forEach(([name, value]) => {
    root.style.setProperty(name, value);
  });
}
